import mapping from "../mappings/buttonHandlersMapping";

export function eventHandlerWrapper (function_name, options) {
  return (e) => {
    // console.log('eventTarget', e.target)
    return mapping[function_name](e, options)
  }
}

